import styled from 'styled-components';
import { Input, Select } from '@shared/ui/Input';

export const CHANGES_PAGE = 50;

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};
`;

export const BlockTitle = styled.h3`
  margin: 0 0 ${({ theme }) => theme.spacing(2)};
  font-size: 15px;
  font-weight: 600;
`;

export const Lead = styled.p`
  margin: 0 0 ${({ theme }) => theme.spacing(3)};
  font-size: 13px;
  line-height: 1.55;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const Grow = styled.span`
  flex: 1;
`;

export const Grid = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;

  th,
  td {
    text-align: left;
    padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(3)}`};
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
    vertical-align: top;
  }

  th {
    font-weight: 600;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.text.secondary};
    background: ${({ theme }) => theme.colors.surface};
  }

  th.num,
  td.num {
    text-align: right;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }

  td.code {
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
    font-weight: 600;
  }

  tr.clickable {
    cursor: pointer;
  }

  tr.clickable:hover td,
  tr.selected td {
    background: ${({ theme }) => theme.colors.surface};
  }
`;

export const TableWrap = styled.div`
  overflow-x: auto;
`;

export const Muted = styled.span`
  color: ${({ theme }) => theme.colors.text.muted};
`;

export const SmallMuted = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.muted};
  margin-top: ${({ theme }) => theme.spacing(0.5)};
`;

export const Note = styled.div`
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.muted};
  padding: ${({ theme }) => `${theme.spacing(2)} 0`};
`;

export const Alert = styled.div<{ $tone: 'danger' | 'success' | 'info' }>`
  margin: ${({ theme }) => `${theme.spacing(2)} 0`};
  padding: ${({ theme }) => theme.spacing(3)};
  border-radius: ${({ theme }) => theme.radius.md};
  font-size: 13px;
  line-height: 1.5;
  border: 1px solid ${({ theme, $tone }) => theme.colors.status[$tone]}55;
  background: ${({ theme, $tone }) => theme.colors.status[$tone]}12;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: ${({ theme }) => theme.spacing(3)};
  margin: ${({ theme }) => `${theme.spacing(3)} 0`};
`;

export const Stat = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};

  & .label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    color: ${({ theme }) => theme.colors.text.muted};
  }

  & .value {
    font-size: 20px;
    font-weight: 700;
    margin-top: ${({ theme }) => theme.spacing(1)};
    font-variant-numeric: tabular-nums;
  }

  & .sub {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.text.secondary};
    margin-top: ${({ theme }) => theme.spacing(1)};
    line-height: 1.5;
  }
`;

export const Plus = styled.span`
  color: ${({ theme }) => theme.colors.status.success};
  font-weight: 600;
`;

export const Minus = styled.span`
  color: ${({ theme }) => theme.colors.status.danger};
  font-weight: 600;
`;

export const Tilde = styled.span`
  color: ${({ theme }) => theme.colors.status.warning};
  font-weight: 600;
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  margin: ${({ theme }) => `${theme.spacing(4)} 0`};
`;

export const FilterInput = styled(Input)`
  flex: 1 1 240px;
  min-width: 180px;
`;

export const FilterSelect = styled(Select)`
  flex: 0 1 200px;
  width: auto;
`;

export const Chip = styled.button<{ $active: boolean }>`
  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(3)}`};
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : theme.colors.border)};
  background: ${({ theme, $active }) => ($active ? theme.colors.primarySoft : 'transparent')};
  color: inherit;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
`;

export const ExternalLink = styled.a`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.primary};
`;
